const TOKEN_KEY = "APIKey";
const LAST_CHECK_KEY = "LastAuthCheck";

const storeToken = (token) => window.localStorage.setItem(TOKEN_KEY, token);

const getToken = () => window.localStorage.getItem(TOKEN_KEY);

const storeLastAuthCheck = () => window.localStorage.setItem(LAST_CHECK_KEY, new Date());

export { storeToken, getToken, storeLastAuthCheck };